import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, OnInit } from '@angular/core';
import { ZoomEnum } from '../../../../modules/planner.module/models/zoom-enum';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
    selector: 'pq-scheduler-zoom',
    templateUrl: './scheduler-zoom.component.html',
    styleUrls: ['./scheduler-zoom.component.scss'],
    standalone: false
})
export class SchedulerZoomComponent implements OnChanges, OnInit {

    @Input('zoomValue') public zoom: ZoomEnum;

    @Output('zoomValueChange') public zoomChange = new EventEmitter<ZoomEnum>();

    public displayValue: string;
    private zoomStorageKey = 'Scheduler_Zoom';

    constructor(private localStorageService: LocalStorageService) {
    }

    public ngOnInit() {
        const storedZoom = this.getStoredValue();
        if (storedZoom && storedZoom !== this.zoom) {
            Promise.resolve(null)
                .then(() => this.updateZoom(storedZoom));
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.zoom) {
            this.setDisplayValue();
        }
    }

    public onChangeZoom($event, descreaseZoom: boolean) {
        $event.stopPropagation();
        const zoomNew = descreaseZoom ? this.getSmallerZoom() : this.getBiggerZoom();

        if (zoomNew) {
            this.setStoredValue(zoomNew);
            this.updateZoom(zoomNew);
        }
    }

    private updateZoom(zoomNew: ZoomEnum) {
        this.zoom = zoomNew;
        this.setDisplayValue();
        this.zoomChange.emit(zoomNew);
    }

    private getSmallerZoom(): ZoomEnum {
        switch (this.zoom) {
            case ZoomEnum.x6:
                return ZoomEnum.x4;
            case ZoomEnum.x4:
                return ZoomEnum.x3;
            case ZoomEnum.x3:
                return ZoomEnum.x2;
            case ZoomEnum.x2:
                return ZoomEnum.x1;
        }

        return null;
    }

    private getBiggerZoom(): ZoomEnum {
        switch (this.zoom) {
            case ZoomEnum.x1:
                return ZoomEnum.x2;
            case ZoomEnum.x2:
                return ZoomEnum.x3;
            case ZoomEnum.x3:
                return ZoomEnum.x4;
            case ZoomEnum.x4:
                return ZoomEnum.x6;
        }

        return null;
    }

    private setDisplayValue() {
        switch (this.zoom) {
            case ZoomEnum.x1:
                this.displayValue = '100%';
                break;
            case ZoomEnum.x2:
                this.displayValue = '200%';
                break;
            case ZoomEnum.x3:
                this.displayValue = '300%';
                break;
            case ZoomEnum.x4:
                this.displayValue = '400%';
                break;
            case ZoomEnum.x6:
                this.displayValue = '600%';
                break;
        }
    }

    private getStoredValue(): ZoomEnum {
        return this.localStorageService.retrieve(this.zoomStorageKey);
    }

    private setStoredValue(value: ZoomEnum) {
        if (value) {
            this.localStorageService.store(this.zoomStorageKey, value);
        } else {
            this.localStorageService.clear(this.zoomStorageKey);
        }
    }
}
